const SIZES = ['S', 'M', 'L', 'XL', 'XXL'];

const BUNDLES = {
  '1': { sku: 'IPC-1PK', label: 'Buy 1', title: '1 Pack', units: 1, price: 64.99, desc: '1 posture corrector', packValues: ['1 Pack', '1 pack', 'Buy 1', '1'] },
  '2': { sku: 'IPC-2PK', label: 'Buy 1 Get 1 Free', title: '2 Pack', units: 2, price: 69.99, desc: '2 posture correctors', recommended: true, nudge: 'Only $5 more than 1 pack', packValues: ['2 Pack', '2 pack', 'Buy 1 Get 1 Free', '2'] },
  '4': { sku: 'IPC-4PK', label: 'Buy 2 Get 2 Free', title: '4 Pack', units: 4, price: 89.99, desc: '4 posture correctors', bestValue: true, packValues: ['4 Pack', '4 pack', 'Buy 2 Get 2 Free', '4'] },
};

function formatPrice(centsOrDollars, isCents) {
  const dollars = isCents ? centsOrDollars / 100 : centsOrDollars;
  return '$' + dollars.toFixed(2);
}

function getActiveBundleOption() {
  return document.querySelector('.bundle-option.is-open') || document.querySelector('.bundle-option.selected');
}

function getSelectedBundleId() {
  const selected = getActiveBundleOption();
  return selected?.dataset.bundle || '2';
}

function getSizeOptions() {
  const el = document.getElementById('product-size-options');
  if (!el) return SIZES;
  try {
    const parsed = JSON.parse(el.textContent);
    return parsed.length ? parsed : SIZES;
  } catch {
    return SIZES;
  }
}

function getUnitSizes() {
  const option = getActiveBundleOption();
  const list = option?.querySelector('.bundle-unit-size-list');
  if (!list) return ['M'];
  const bundleId = option.dataset.bundle;
  const units = BUNDLES[bundleId]?.units || 1;
  const sizes = [];
  for (let i = 1; i <= units; i += 1) {
    const selected = list.querySelector(`.unit-size-select[data-unit="${i}"]`);
    sizes.push(selected?.value || 'M');
  }
  return sizes.length ? sizes : ['M'];
}

function renderSizeListInto(list, units, bundleId) {
  const sizes = getSizeOptions();
  const defaultSize = 'M';

  list.innerHTML = '';
  for (let i = 1; i <= units; i += 1) {
    const row = document.createElement('div');
    row.className = 'bundle-unit-size-row';
    const selectId = `unit-size-${bundleId}-${i}`;
    row.innerHTML = `
      <label class="unit-label" for="${selectId}">${units === 1 ? 'Size' : `Item ${i}`}</label>
      <select id="${selectId}" class="unit-size-select" data-unit="${i}" aria-label="Size for item ${i}">
        ${sizes.map((size) => `<option value="${size}"${size === defaultSize ? ' selected' : ''}>${size}</option>`).join('')}
      </select>
    `;
    list.appendChild(row);
  }

  list.querySelectorAll('.unit-size-select').forEach((select) => {
    select.addEventListener('click', (event) => event.stopPropagation());
    select.addEventListener('change', (event) => {
      event.stopPropagation();
      syncVariantFromProduct();
    });
  });
}

function renderAllBundleSizes() {
  document.querySelectorAll('.bundle-option').forEach((option) => {
    const bundleId = option.dataset.bundle;
    const units = BUNDLES[bundleId]?.units || 1;
    const list = option.querySelector('.bundle-unit-size-list');
    if (!list) return;
    renderSizeListInto(list, units, bundleId);

    const label = option.querySelector('.bundle-sizes-label');
    if (label) {
      label.textContent = units === 1 ? 'Select your size' : `Select size for each item (${units})`;
    }
  });
}

function openBundleAccordion(optionEl) {
  document.querySelectorAll('.bundle-option').forEach((option) => {
    option.classList.remove('selected', 'is-open');
    option.querySelector('.bundle-option-sizes')?.setAttribute('aria-hidden', 'true');
  });

  optionEl.classList.add('selected', 'is-open');
  optionEl.querySelector('.bundle-option-sizes')?.setAttribute('aria-hidden', 'false');
}

function syncVariantFromProduct() {
  syncProductVariant?.();
}

function getSelectedSize() {
  return getUnitSizes()[0] || 'M';
}

function buildLineItemProperties(bundle, sizes) {
  const properties = {
    Bundle: bundle.label,
    Pack: bundle.title,
    Sizes: sizes.join(', '),
  };
  sizes.forEach((size, index) => {
    properties[`Item ${index + 1} Size`] = size;
  });
  return properties;
}

function getSelectedOptionValue(optionName) {
  const group = document.querySelector(`.variant-group[data-option-name="${optionName}"]`);
  if (!group) {
    const groups = document.querySelectorAll('.variant-group');
    for (const g of groups) {
      const label = g.querySelector('.variant-label span')?.textContent?.trim();
      if (label === optionName) {
        return g.querySelector('.variant-btn.selected')?.dataset.value || null;
      }
    }
    return null;
  }
  return group.querySelector('.variant-btn.selected')?.dataset.value || null;
}

function getSelectedColor() {
  return getSelectedOptionValue('Color') || 'Black';
}

function getPackOptionName() {
  const selector = document.querySelector('.bundle-selector');
  return selector?.dataset.packOption || 'Pack';
}

function getSelectedPackValue() {
  const bundleId = getSelectedBundleId();
  const bundle = BUNDLES[bundleId];
  const btn = document.querySelector(`.bundle-option[data-bundle="${bundleId}"]`);
  return btn?.dataset.packValue || bundle?.packValues?.[0] || `${bundleId} Pack`;
}

function parseVariantData() {
  const el = document.getElementById('product-variant-data');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch {
    return [];
  }
}

function findMatchingVariant(variants, selections) {
  if (!variants.length) return null;
  const entries = Object.entries(selections).filter(([, v]) => v);
  return variants.find((variant) => {
    const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    return entries.every(([, val]) => opts.some((o) => o === val || o?.includes(val) || val?.includes(o)));
  }) || variants.find((variant) => {
    const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    const size = selections.Size;
    const pack = selections.Pack;
    return (!size || opts.includes(size)) && (!pack || opts.some((o) => packMatch(o, pack)));
  });
}

function packMatch(optionValue, packValue) {
  if (!optionValue || !packValue) return false;
  if (optionValue === packValue) return true;
  const bundleEntry = Object.values(BUNDLES).find((b) => b.packValues.includes(packValue));
  if (bundleEntry && bundleEntry.packValues.includes(optionValue)) return true;
  const num = packValue.match(/\d+/)?.[0];
  return num && (optionValue.includes(num) || optionValue.startsWith(num));
}

function updateProductUI(variant) {
  const bundleId = getSelectedBundleId();
  const bundle = BUNDLES[bundleId];
  const sizes = getUnitSizes();
  const color = getSelectedColor();
  const sizesLabel = sizes.length === 1 ? `Size ${sizes[0]}` : `Sizes: ${sizes.join(', ')}`;

  const priceEl = document.getElementById('live-price');
  const skuEl = document.getElementById('live-sku');
  const includedEl = document.getElementById('included-qty');
  const purchaseBtn = document.getElementById('purchase');
  const mobilePurchase = document.getElementById('mobile-purchase');
  const mobilePrice = document.getElementById('mobile-price');
  const finalCta = document.getElementById('final-checkout-cta');
  const variantSelect = document.getElementById('product-variant-select');

  let priceText;
  let skuText;
  const primarySize = sizes[0];

  if (variant) {
    priceText = formatPrice(variant.price, true);
    skuText = variant.sku || `${bundle.sku}-${primarySize}`;
    if (variantSelect) variantSelect.value = variant.id;
  } else {
    priceText = formatPrice(bundle.price, false);
    skuText = `${bundle.sku}-${primarySize}`;
  }

  const includedText = sizes.length === 1
    ? `${bundle.units}× Adjustable Posture Corrector Brace (${color}, Size ${sizes[0]})`
    : `${bundle.units}× Adjustable Posture Corrector Brace (${color}) — ${sizes.map((size, index) => `#${index + 1}: ${size}`).join(', ')}`;

  const eluxPrice = document.getElementById('elux-display-price');
  if (eluxPrice) eluxPrice.textContent = priceText;
  if (priceEl) priceEl.textContent = priceText;
  if (skuEl) skuEl.innerHTML = `SKU: <strong>${skuText}</strong> · ${color} · ${sizesLabel}`;
  if (includedEl) includedEl.textContent = includedText;
  const addLabel = `Add to Cart — ${priceText}`;
  if (purchaseBtn) purchaseBtn.textContent = addLabel;
  if (mobilePurchase) mobilePurchase.textContent = 'Add to Cart';
  if (mobilePrice) mobilePrice.textContent = priceText;
  if (finalCta) finalCta.textContent = `Proceed to Checkout — ${priceText}`;
}

let syncProductVariant = null;

function productBundleSelector() {
  const variants = parseVariantData();
  const variantSelect = document.getElementById('product-variant-select');
  if (!document.querySelector('.bundle-selector')) return;

  function syncVariant() {
    const packName = getPackOptionName();
    const selections = {
      [packName]: getSelectedPackValue(),
      Size: getSelectedSize(),
      Color: getSelectedColor(),
      Pack: getSelectedPackValue(),
    };
    const match = findMatchingVariant(variants, selections);
    updateProductUI(match);
    if (match && variantSelect) {
      variantSelect.value = match.id;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncProductVariant = syncVariant;

  renderAllBundleSizes();

  const params = new URLSearchParams(window.location.search);
  const preset = params.get('bundle');
  let initialOption = null;

  if (preset && BUNDLES[preset]) {
    initialOption = document.querySelector(`.bundle-option[data-bundle="${preset}"]`);
  } else {
    initialOption =
      document.querySelector('.bundle-option.selected') ||
      document.querySelector('.bundle-option[data-bundle="2"]');
  }

  if (initialOption) {
    openBundleAccordion(initialOption);
  }

  document.querySelectorAll('.bundle-option-header').forEach((header) => {
    header.addEventListener('click', () => {
      const option = header.closest('.bundle-option');
      if (!option) return;
      openBundleAccordion(option);
      syncVariant();
    });
  });

  document.querySelectorAll('.bundle-size-guide-link').forEach((link) => {
    link.addEventListener('click', (event) => event.stopPropagation());
  });

  document.querySelectorAll('.variant-group .variant-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      syncVariant();
    });
  });

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const selected = variants.find((v) => String(v.id) === variantSelect.value);
      if (selected) updateProductUI(selected);
    });
  }

  syncVariant();
}

function initProductAddToCart() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const variants = parseVariantData();
    const packName = getPackOptionName();
    const bundleId = getSelectedBundleId();
    const bundle = BUNDLES[bundleId];
    const sizes = getUnitSizes();
    const selections = {
      [packName]: getSelectedPackValue(),
      Size: sizes[0],
      Color: getSelectedColor(),
      Pack: getSelectedPackValue(),
    };
    const variant = findMatchingVariant(variants, selections);

    if (!variant) {
      alert('Please select available pack and size options.');
      return;
    }

    const properties = buildLineItemProperties(bundle, sizes);
    const buttons = [
      document.getElementById('purchase'),
      document.getElementById('mobile-purchase'),
    ].filter(Boolean);

    buttons.forEach((btn) => {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          properties,
        }),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Could not add to cart');
      }

      const cart = await fetchCart();
      renderCartDrawer(cart);
      openCartDrawer();
      buttons.forEach((btn) => {
        btn.disabled = false;
        btn.textContent = btn.id === 'mobile-purchase' ? 'Add to Cart' : `Add to Cart — ${document.getElementById('live-price')?.textContent || ''}`;
      });
    } catch (error) {
      alert(error.message || 'Could not add to cart. Please try again.');
      syncProductVariant?.();
      buttons.forEach((btn) => {
        btn.disabled = false;
        btn.textContent = btn.id === 'mobile-purchase' ? 'Add to Cart' : `Add to Cart — ${document.getElementById('live-price')?.textContent || ''}`;
      });
    }
  });
}

function initCartPage() {
  const cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  cartForm.querySelectorAll('.cart-remove-btn').forEach((button) => {
    button.addEventListener('click', async () => {
      const line = Number(button.dataset.line);
      if (!line) return;

      button.disabled = true;
      try {
        await changeCartLine(line, 0);
        window.location.reload();
      } catch {
        button.disabled = false;
        alert('Could not remove item. Please try again.');
      }
    });
  });
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

async function fetchCart() {
  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Cart fetch failed');
  return response.json();
}

async function changeCartLine(line, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ line, quantity }),
  });
  if (!response.ok) throw new Error('Update failed');
  const cart = await response.json();
  renderCartDrawer(cart);
  return cart;
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('cart-drawer-items');
  const emptyEl = document.getElementById('cart-drawer-empty');
  const footerEl = document.getElementById('cart-drawer-footer');
  const countEl = document.getElementById('cart-drawer-count');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  const headerCount = document.querySelector('.header-cart-count');

  if (!itemsEl) return;

  if (headerCount) {
    headerCount.textContent = cart.item_count;
    headerCount.classList.toggle('is-empty', cart.item_count === 0);
  }
  if (countEl) countEl.textContent = `(${cart.item_count})`;
  if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price, true);

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '';
    emptyEl?.removeAttribute('hidden');
    footerEl?.setAttribute('hidden', '');
    return;
  }

  emptyEl?.setAttribute('hidden', '');
  footerEl?.removeAttribute('hidden');

  itemsEl.innerHTML = cart.items.map((item, index) => {
    const props = Object.entries(item.properties || {})
      .filter(([key, value]) => value && !key.startsWith('_'))
      .map(([key, value]) => `<li>${escapeHtml(key)}: ${escapeHtml(value)}</li>`)
      .join('');

    const image = item.image
      ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" width="64" height="64" loading="lazy">`
      : '';

    const variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span class="cart-drawer-variant">${escapeHtml(item.variant_title)}</span>`
      : '';

    return `
      <article class="cart-drawer-item" data-key="${escapeHtml(item.key)}">
        <div class="cart-drawer-item-image">${image}</div>
        <div class="cart-drawer-item-info">
          <strong>${escapeHtml(item.product_title)}</strong>
          ${variantLine}
          ${props ? `<ul class="cart-drawer-props">${props}</ul>` : ''}
          <button type="button" class="cart-drawer-remove" data-line="${index + 1}">Remove</button>
        </div>
        <div class="cart-drawer-item-price">${formatPrice(item.final_line_price, true)}</div>
      </article>
    `;
  }).join('');

  itemsEl.querySelectorAll('.cart-drawer-remove').forEach((button) => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        await changeCartLine(Number(button.dataset.line), 0);
      } catch {
        button.disabled = false;
      }
    });
  });
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
}

function initCartDrawer() {
  document.querySelectorAll('[data-cart-open]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      fetchCart()
        .then((cart) => {
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(() => openCartDrawer());
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach((el) => {
    el.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });
}

function initCheckout() {
  const params = new URLSearchParams(window.location.search);
  const bundleId = params.get('bundle') || '2';
  const size = params.get('size') || 'M';
  const bundle = BUNDLES[bundleId] || BUNDLES['2'];

  const setText = (id, text) => {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  };

  setText('checkout-title', bundle.label);
  setText('checkout-units', `${bundle.units}× Adjustable Posture Corrector Brace · Size ${size}`);
  setText('checkout-sku', `SKU: ${bundle.sku}-${size} · Black`);
  setText('checkout-line-price', formatPrice(bundle.price, false));
  setText('checkout-total', formatPrice(bundle.price, false));
  setText('checkout-btn-price', formatPrice(bundle.price, false));
  setText('checkout-bundle-note', `${bundle.label} — ${bundle.units} unit${bundle.units > 1 ? 's' : ''} total`);
  setText('checkout-summary-qty', `${bundle.units}×`);
}

function initCheckoutForm() {
  const form = document.getElementById('checkout-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    const bundleId = params.get('bundle') || '2';
    const size = params.get('size') || 'M';
    const email = form.querySelector('[name="email"]')?.value || '';
    const orderNum = 'TPC-' + Date.now().toString().slice(-8);
    const confirmUrl = new URL('order-confirmation.html', window.location.href);
    confirmUrl.searchParams.set('bundle', bundleId);
    confirmUrl.searchParams.set('size', size);
    confirmUrl.searchParams.set('order', orderNum);
    if (email) confirmUrl.searchParams.set('email', encodeURIComponent(email));
    window.location.href = confirmUrl.toString();
  });
}

function initOrderConfirmation() {
  const params = new URLSearchParams(window.location.search);
  const bundleId = params.get('bundle') || '2';
  const size = params.get('size') || 'M';
  const order = params.get('order') || 'TPC-PENDING';
  const email = params.get('email') ? decodeURIComponent(params.get('email')) : 'your email';
  const bundle = BUNDLES[bundleId] || BUNDLES['2'];

  const setText = (id, text) => {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  };

  setText('confirm-order', order);
  setText('confirm-email', email);
  setText('confirm-total', formatPrice(bundle.price, false));
  setText('confirm-items', `${bundle.units}× Adjustable Posture Corrector Brace (${size})`);
  setText('confirm-bundle', bundle.label);
}

function initFloatShopBar() {
  const bar = document.querySelector('.float-shop-bar');
  if (!bar) return;
  document.body.classList.add('has-float-bar');
}

function initFaqAccordion() {
  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach((i) => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });
}

function setMainProductImage(src, alt) {
  const mainImg = document.getElementById('main-product-img');
  if (!mainImg || !src) return false;

  mainImg.src = src;
  mainImg.srcset = '';
  mainImg.removeAttribute('srcset');
  mainImg.removeAttribute('sizes');
  if (alt) mainImg.alt = alt;
  return true;
}

function initProductGallery() {
  const track = document.getElementById('product-thumbs-track');
  const prevBtn = document.querySelector('.product-thumbs-prev');
  const nextBtn = document.querySelector('.product-thumbs-next');
  const scrollStep = 200;

  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      const src = thumb.dataset.src || thumb.querySelector('img')?.currentSrc || thumb.querySelector('img')?.src;
      const alt = thumb.dataset.alt || thumb.querySelector('img')?.alt || '';
      if (!setMainProductImage(src, alt)) return;

      document.querySelectorAll('.product-thumb').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  function updateThumbArrows() {
    if (!track || !prevBtn || !nextBtn) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const needsArrows = maxScroll > 4;

    prevBtn.classList.toggle('is-hidden', !needsArrows);
    nextBtn.classList.toggle('is-hidden', !needsArrows);

    if (!needsArrows) return;

    prevBtn.disabled = track.scrollLeft <= 2;
    nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
  }

  prevBtn?.addEventListener('click', () => {
    track?.scrollBy({ left: -scrollStep, behavior: 'smooth' });
  });

  nextBtn?.addEventListener('click', () => {
    track?.scrollBy({ left: scrollStep, behavior: 'smooth' });
  });

  track?.addEventListener('scroll', updateThumbArrows, { passive: true });
  window.addEventListener('resize', updateThumbArrows);
  updateThumbArrows();
}

function initProductTabs() {
  document.querySelectorAll('.tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabs = btn.closest('.product-tabs');
      const target = btn.dataset.tab;
      tabs.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'));
      tabs.querySelectorAll('.tab-panel').forEach((p) => p.classList.remove('active'));
      btn.classList.add('active');
      tabs.querySelector(`[data-panel="${target}"]`)?.classList.add('active');
    });
  });
}

function initMobileNav() {
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.nav');
  const siteNav = document.getElementById('site-nav');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => nav.classList.toggle('open'));
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => nav.classList.remove('open'));
    });
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target) && !menuToggle.contains(e.target)) {
        nav.classList.remove('open');
      }
    });
  }

  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', () => {
      const open = siteNav.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
}

function initTrackOrderForm() {
  const form = document.getElementById('track-order-form');
  if (!form) return;

  form.addEventListener('submit', () => {
    const orderInput = form.querySelector('[name="order_number"]');
    if (!orderInput?.value) return;
    orderInput.value = orderInput.value.replace(/^#/, '').trim();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initFaqAccordion();
  initProductGallery();
  initProductTabs();
  productBundleSelector();
  initProductAddToCart();
  initCartPage();
  initCartDrawer();
  initTrackOrderForm();
  initFloatShopBar();

  if (document.getElementById('checkout-total')) initCheckout();
  initCheckoutForm();
  if (document.getElementById('confirm-order')) initOrderConfirmation();
});
